import { createSlice } from '@reduxjs/toolkit';
import {
  fetchAppointmentsThunk,
  fetchUpcomingAppointmentsThunk,
  createAppointmentThunk,
  updateAppointmentThunk,
  deleteAppointmentThunk,
} from '../thunks/appointmentsThunks';

const initialState = {
  items: [],
  upcoming: [],
  loading: false,
  error: null,

  scheduling: false,
  schedulingError: null,
};

const appointmentsSlice = createSlice({
  name: 'appointments',
  initialState,
  reducers: {
    setAppointments: (state, action) => {
      state.items = action.payload;
    },
    addAppointment: (state, action) => {
      state.items.push(action.payload);
    },
    updateAppointment: (state, action) => {
      const { id, changes } = action.payload;
      const index = state.items.findIndex(appt => appt._id === id);
      if (index !== -1) {
        state.items[index] = { ...state.items[index], ...changes };
      }
      // Also update in upcoming if present
      const upcomingIndex = state.upcoming.findIndex(appt => appt._id === id);
      if (upcomingIndex !== -1) {
        state.upcoming[upcomingIndex] = { ...state.upcoming[upcomingIndex], ...changes };
      }
    },
    removeAppointment: (state, action) => {
      state.items = state.items.filter(appt => appt._id !== action.payload);
      state.upcoming = state.upcoming.filter(appt => appt._id !== action.payload);
    },
    setUpcoming: (state, action) => {
      state.upcoming = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchAppointmentsThunk
      .addCase(fetchAppointmentsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAppointmentsThunk.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchAppointmentsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // fetchUpcomingAppointmentsThunk
      .addCase(fetchUpcomingAppointmentsThunk.fulfilled, (state, action) => {
        state.upcoming = action.payload;
      })

      // createAppointmentThunk
      .addCase(createAppointmentThunk.pending, (state) => {
        state.scheduling = true;
        state.schedulingError = null;
      })
      .addCase(createAppointmentThunk.fulfilled, (state, action) => {
        state.items.push(action.payload);
        state.scheduling = false;
      })
      .addCase(createAppointmentThunk.rejected, (state, action) => {
        state.scheduling = false;
        state.schedulingError = action.error.message;
      })

      // updateAppointmentThunk
      .addCase(updateAppointmentThunk.fulfilled, (state, action) => {
        const updated = action.payload;
        const index = state.items.findIndex(appt => appt._id === updated._id);
        if (index !== -1) {
          state.items[index] = updated;
        }
        const upcomingIndex = state.upcoming.findIndex(appt => appt._id === updated._id);
        if (upcomingIndex !== -1) {
          state.upcoming[upcomingIndex] = updated;
        }
      })

      // deleteAppointmentThunk
      .addCase(deleteAppointmentThunk.fulfilled, (state, action) => {
        const id = action.meta.arg;
        state.items = state.items.filter(appt => appt._id !== id);
        state.upcoming = state.upcoming.filter(appt => appt._id !== id);
      });
  },
});

export const {
  setAppointments,
  addAppointment,
  updateAppointment,
  removeAppointment,
  setUpcoming,
} = appointmentsSlice.actions;

export default appointmentsSlice.reducer;
